import { render, staticRenderFns } from "./RoundtableList.vue?vue&type=template&id=6ca7ba8e"
import script from "./RoundtableList.vue?vue&type=script&lang=js"
export * from "./RoundtableList.vue?vue&type=script&lang=js"
import style0 from "./RoundtableList.vue?vue&type=style&index=0&id=6ca7ba8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports